import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["children", "className", "style", "onDoubleClick", "rehypePlugins", "remarkPlugins", "components"];
import { Collapse, Divider, Typography } from 'antd';
import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import { withProvider } from '..';
import { Code } from "./CodeBlock";
import { useStyles } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
var MemoHr = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/_jsx(Divider, _objectSpread({
    style: {
      marginBottom: '1em',
      marginTop: 0
    }
  }, props));
});
var MemoDetails = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/_jsx(Collapse, _objectSpread({
    style: {
      marginBottom: '1em'
    }
  }, props));
});
var MemoImage = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/_jsx("img", _objectSpread({}, props));
});
var MemoAlink = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/_jsx(Typography.Link, _objectSpread({}, props));
});
var Markdown = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    onDoubleClick = _ref.onDoubleClick,
    outRehypePlugins = _ref.rehypePlugins,
    outRemarkPlugins = _ref.remarkPlugins,
    outComponents = _ref.components,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var components = _objectSpread({
    details: MemoDetails,
    hr: MemoHr,
    a: MemoAlink,
    img: MemoImage,
    pre: Code
  }, outComponents);
  var rehypePlugins = [rehypeKatex].concat(_toConsumableArray(outRehypePlugins || []));
  var remarkPlugins = [[remarkGfm, {
    singleTilde: false
  }], remarkMath].concat(_toConsumableArray(outRemarkPlugins || []));
  return /*#__PURE__*/_jsx(Typography, {
    className: className,
    onDoubleClick: onDoubleClick,
    style: style,
    children: /*#__PURE__*/_jsx(ReactMarkdown, _objectSpread(_objectSpread({
      className: styles.markdown,
      components: components,
      rehypePlugins: rehypePlugins,
      remarkPlugins: remarkPlugins
    }, rest), {}, {
      children: children
    }))
  });
});
export default withProvider(Markdown);